/* Buy-box add-on fixes:
   1) the ×N multiplier must disappear on the 1-unit tier (its display rule was
      beating the hidden attribute);
   2) the add-on price on the right always shows the UNIT price, whatever bundle
      is selected — derived from the block's own data-price so a preselected
      multi-unit tier can't bake a doubled figure in. */
(function () {
  var st = document.createElement('style');
  st.textContent = '.ch-add__mult[hidden]{display:none !important}';
  document.head.appendChild(st);

  function fmt(cents) {
    var f = window.CH_MONEY_FORMAT || '${{amount}}';
    var n = (cents / 100).toFixed(2);
    return f
      .replace(/\{\{\s*amount\s*\}\}/, n)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, String(Math.round(cents / 100)));
  }

  function pin() {
    Array.prototype.forEach.call(document.querySelectorAll('.ch-add[data-ch-addon]'), function (row) {
      var out = row.querySelector('[data-add-now]');
      if (!out || out.dataset.chPinned) return;
      var cents = parseInt(row.getAttribute('data-price') || '0', 10);
      if (!cents) return;
      out.dataset.chPinned = '1';
      var unit = fmt(cents);
      out.textContent = unit;
      new MutationObserver(function () {
        if (out.textContent !== unit) out.textContent = unit;
      }).observe(out, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pin);
  else pin();
  document.addEventListener('shopify:section:load', pin);
})();
